import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import { HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';
import SubscriptionConfirmationPageContent from '../PageContent/SubscriptionConfirmationPageContent';


const SubscriptionConfirmationNoLicense = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="md" backButton={false}>
            <SubscriptionConfirmationPageContent hasLicense={false} />
        </HeaderAndBodyLayout>
    );
};

export default SubscriptionConfirmationNoLicense;

